// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'

import store from './store'
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/zh-CN'
import VueAwesomeSwiper from 'vue-awesome-swiper'
// 视频播放
import VueVideoPlayer from 'vue-video-player'
// 无缝滚动
import vueSeamlessScroll from 'vue-seamless-scroll'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/css/el-theme/index.css'
import './assets/css/home.css'
import './assets/css/newhome.css'
import './assets/css/common.css'
import 'video.js/dist/video-js.css'

// 图表
import HighchartsVue from 'highcharts-vue'
import Highcharts from 'highcharts'
import mapInit from 'highcharts/modules/map'
import addguangdong from '@/assets/js/guangdong.js'
mapInit(Highcharts)
addguangdong(Highcharts)
Vue.use(HighchartsVue)
// 复制到粘贴板插件
import VueClipboard from 'vue-clipboard2'
VueClipboard.config.autoSetContainer = true
Vue.use(VueClipboard)
// 自定义右键菜单
import Contextmenu from "vue-contextmenujs"
Vue.use(Contextmenu);
// 查看大图
import VueDirectiveImagePreviewer from 'vue-directive-image-previewer'
import 'vue-directive-image-previewer/dist/assets/style.css'
Vue.use(VueDirectiveImagePreviewer)

// 引入部分antdvue
import anchor from 'ant-design-vue/lib/anchor'; // 加载 JS
import statistic from 'ant-design-vue/lib/statistic'; // 加载 JS
import Progress  from 'ant-design-vue/lib/progress'; // 加载 JS
import tooltip  from 'ant-design-vue/lib/tooltip'; // 加载 JS
import 'ant-design-vue/lib/anchor/style/index.css'; //局部样式
import 'ant-design-vue/lib/statistic/style/index.css'; //局部样式
import 'ant-design-vue/lib/progress/style/index.css'; //局部样式
import 'ant-design-vue/lib/tooltip/style/index.css'; //局部样式
Vue.use(anchor)
Vue.use(statistic)
Vue.use(Progress)
Vue.use(tooltip)

// 动画插件
import 'vue2-animate/dist/vue2-animate.min.css'
// iconfont
import './assets/css/iconfont.css'

import './assets/css/swiper.css'
import 'element-ui/lib/theme-chalk/base.css';
// 防止按钮重复提交
import preventReClick from './api/tool/preventReClick'

import router from './router'
// import xgplayer from 'xgplayer'
// Vue.use(xgplayer)
// collapse 展开折叠
import CollapseTransition from 'element-ui/lib/transitions/collapse-transition';
import * as filter from './filter' // global filters
import i18n from './locale/index' //国际化

//import './permission' // permission control
Vue.component(CollapseTransition.name, CollapseTransition)
// register global utility filters
Object.keys(filter).forEach(key => {
  Vue.filter(key, filter[key])
})

Vue.use(VueVideoPlayer)
Vue.use(VueAwesomeSwiper)
Vue.use(ElementUI, { locale })
Vue.config.productionTip = false

Vue.prototype.$fileServer = process.env.fileServer
Vue.prototype.$baseUrl = process.env.baseUrl

import empty from '@/components/states/empty'
import state404 from '@/components/states/state404'
import success from '@/components/states/success'
Vue.component("empty", empty);
Vue.component("state404", state404);
Vue.component("success", success);
Vue.directive('focus', function (el) {
  el.querySelector('input').focus()
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js